<template>
    <div class="modal newsletter-panel right" id="newsletter-panel">
        <a href="#" class="close-button" @click.prevent="close()">
            <span class="icon-cross"></span>
            Fermer
        </a>

        <div class="content mCustomScrollbar">
            <!--ScrollBar-->
            <transition name="slide-fade" mode="out-in">
                <div key="success-message" v-if="submitted">
                    <p class="margin"></p>
                    <p class="merci">Merci !</p>
                    <p class="okmsg">Vous êtes abonné(e) à notre newsletter !<br>
                        <br>
                        Vous allez recevoir un mail de confirmation, n’oubliez pas de cliquer
                        sur le lien pour activer votre abonnement !</p>
                    <a href="#" class="btn chevron goback" @click.prevent="close()">Retour</a>
                </div>
                <div key="newsletter-form" v-else>
                    <h2 class="titre">Newsletter</h2>
                    <p>Nos newsletters vous parlent de l’actualité des pôles, du tourisme, mais surtout de la vie de
                        l’équipe et de l’agence… Vous pouvez les recevoir en remplissant le formulaire suivant :</p>
                    <form @submit.prevent="submit()">

                        <div class="row">
                            <div class="col-12 col-lg-4 col-label"></div>
                            <div class="col-12 col-lg-8">
                                <div class="form-item">
                                    <label for="prenom-newsletter">Votre prénom *</label>
                                    <input type="text"
                                           id="prenom-newsletter"
                                           required
                                           v-model="form.firstName">
                                </div>
                                <p v-for="error in errors.get('first_name')">{{ error }}</p>
                            </div>

                            <div class="col-12 col-lg-4 col-label"></div>
                            <div class="col-12 col-lg-8">
                                <div class="form-item">
                                    <label for="nom-newsletter">Votre nom *</label>
                                    <input type="text"
                                           id="nom-newsletter"
                                           required
                                           v-model="form.lastName">
                                </div>
                                <p v-for="error in errors.get('last_name')">{{ error }}</p>
                            </div>

                            <div class="col-12 col-lg-4 col-label"></div>
                            <div class="col-12 col-lg-8">
                                <div class="form-item">
                                    <label for="email-newsletter">Votre E-Mail *</label>
                                    <input type="email"
                                           id="email-newsletter"
                                           required
                                           v-model="form.email">
                                </div>
                                <p v-for="error in errors.get('email')">{{ error }}</p>
                            </div>


                        </div>

                        <div class="cta">
                            <span></span>

                            <button type="submit" class="btn chevron" :disabled="loading">Je m'inscris</button>
                        </div>


                    </form>
                    <p class="margin"></p>

                </div>
            </transition>


        </div>


    </div>


</template>

<script>
    import Modal from '../libs/Modal';
    import ajaxForm from '../mixins/ajaxForm';

    export default {
        mixins: [ajaxForm],
        data: () => ({
            form: {},
        }),
        methods: {
            submit() {
                this.request('ge_subscribe_newsletter', {
                    first_name: this.form.firstName,
                    last_name: this.form.lastName,
                    email: this.form.email,
                });
            },
            reset() {
                this.form = {};
            },
            close() {
                this.submitted = false;
                Modal.hideModal('#newsletter-panel');
            },
        },
    };
</script>



// WEBPACK FOOTER //
// assets/js/components/NewsletterPanel.vue